'use client';
import e__default from 'react';
import { useId } from '../../hooks/use-id.js';
import { useNonNullishFormFieldContext } from './form.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var p = Object.getOwnPropertySymbols(e);
        for(o = 0; o < p.length; o++)t = p[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, p = Object.keys(e);
    for(o = 0; o < p.length; o++)t = p[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const FormHelper = renderWithRef('FormHelper', null, (t, p)=>{
    var { children: c } = t, i = _object_without_properties(t, [
        "children"
    ]);
    let s = useId(i.id), { setHelperIds: u } = useNonNullishFormFieldContext();
    return e__default.useEffect(()=>(s && u((e)=>new Set([
                ...e,
                s
            ])), ()=>{
            s && u((e)=>{
                let r = new Set([
                    ...e
                ]);
                return r.delete(s), r;
            });
        }), [
        s,
        u
    ]), e__default.createElement(RenderComp, {
        root: "p",
        forwardedRef: p,
        props: _object_spread_props(_object_spread({}, i), {
            id: s
        }),
        classNames: [
            'swan-input-group-helper-text'
        ]
    }, c);
});

export { FormHelper };
